import { render, staticRenderFns } from "./sendmail.vue?vue&type=template&id=ab50c6ea&scoped=true&"
import script from "./sendmail.vue?vue&type=script&lang=js&"
export * from "./sendmail.vue?vue&type=script&lang=js&"
import style0 from "./sendmail.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./sendmail.vue?vue&type=style&index=1&id=ab50c6ea&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab50c6ea",
  null
  
)

export default component.exports